import { css } from '@emotion/css'

import { spacing, fontSize, fontWeight, colors } from '@offerzen/pinata-shame'

const styles = {
  checkbox: css({
    marginTop: spacing.default,
  }),
  formHeading: css({
    fontSize: fontSize.medium,
    marginBottom: spacing.medium,
    fontWeight: fontWeight.medium,
    color: colors.blackPearl,
  }),

  notification: css({
    marginTop: spacing.large,
    marginBottom: spacing.large,
  }),

  comprehensiveLocationNotification: css({
    marginBottom: spacing.small,
  }),

  select: css({
    label: {
      marginTop: spacing.small,
    },
  }),

  footer: css({
    marginTop: spacing.large,
  }),
}

export default styles
